import { registerBlockType } from "@wordpress/blocks";
import { Provider } from "react-redux";
import { Icon } from "@wordpress/components";
import store from "store";
import Editor from "./Edit";
import Save from "./Save";

registerBlockType("vino/wine-clubs", {
	title: "Wine Clubs",
	icon: {
		src: <Icon icon="portfolio" />,
	},
	category: "corksy",
	keywords: ["corksy"],
	description: "Display all wine clubs.",
	edit: function (props) {
		return (
			<Provider store={store}>
				<Editor {...props} />
			</Provider>
		);
	},
	save: Save,
});
